import React from "react";
import { ColorConfigs } from './../../configurations';
export default (function () {
    return React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "400", height: "146", fill: "none", viewBox: "0 0 459 146" },
        React.createElement("path", { fill: ColorConfigs.blue, d: "M0 41h62v104H0V41z" }),
        React.createElement("path", { fill: ColorConfigs.blue, d: "M133 94h62v51.2h-62V94z" }),
        React.createElement("path", { fill: ColorConfigs.blue, d: "M266 83h62v62.4h-62V83z" }),
        React.createElement("path", { fill: ColorConfigs.blue, d: "M397 0h62v145h-62V0z" }));
});
//# sourceMappingURL=bar.js.map